// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index']);
  const createGroupReasonCode = `createGroupReasonCode(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createGroupReasonCode} {
      id
    }
  }
`;
};
